export { default } from './svg/layout.svg';
